// Opted-out sites that don't participate in regional gift vouchers
// or venues using an external booking system
// Torino       (RI-TO - 222),
// Taastrup     (MJ-CO - 233),
// Schaumburg   (VO-SB - 237),
// Frisco       (MW-DN - 128),
// Vaughan      (RB-VN - 273),
// Ottawa       (TV-OT - 130),
// Perth        (MS-PE - 83),
// Jacksonville (LL-JK - 115)
// Fort Worth, Hulen (FD-FW - 155)
export const excludedGiftVoucherSiteIds: number[] = [222, 233, 237, 128, 273, 130, 83, 115, 155];
